import script from "./InvalidPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InvalidPage.vue?vue&type=script&setup=true&lang=js"

import "./InvalidPage.vue?vue&type=style&index=0&id=7d6a6d2c&scope=true&lang=css"

const __exports__ = script;

export default __exports__